module.exports = __webpack_public_path__ + "static/media/photo-1547525372-7acfcbcd8acc.530d26f1.jfif";